document.addEventListener('DOMContentLoaded', () => {
    const videoWrappers = document.querySelectorAll('.video-wrapper');

    videoWrappers.forEach(wrapper => {
        const video = wrapper.querySelector('video');
        const playPauseBtn = wrapper.querySelector('.play-pause-btn');
        const iconSpan = playPauseBtn?.querySelector('span');
        const textSpan = playPauseBtn?.querySelector('.sr-only');

        if (!video || !playPauseBtn || !iconSpan || !textSpan) return;

        const updatePlayState = (isPlaying) => {
            iconSpan.classList.toggle('icon-play', !isPlaying);
            iconSpan.classList.toggle('icon-pause', isPlaying);
            textSpan.textContent = isPlaying ? 'Pause' : 'Play';
        };

        playPauseBtn.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();

            if (video.paused) {
                video.play();
            } else {
                video.pause();
            }
        });

        // Prevent click propagation on video
        video.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
        });

        // Update button state when video state changes
        video.addEventListener('play', () => updatePlayState(true));
        video.addEventListener('pause', () => updatePlayState(false));
    });
});